import { constants } from "../resource/constants";

export function getLocationObjForCoordinates({ coords }) {
  return fetch(
    `${constants.urls.googleApi.geocode}?latlng=${coords.latitude},${coords.longitude}&key=${constants.googleApiKey}`
  ).then(res => res.json());
}

export function getCoordinatesForZipCode(zipCode) {
  return fetch(
    `${constants.urls.googleApi.geocode}?address=${zipCode}&key=${constants.googleApiKey}`
  )
    .then(res => res.json())
    .then(res => [
      res.results[0].geometry.location.lat,
      res.results[0].geometry.location.lng
    ]);
}
